import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../css/adminNav.css";
import Logo from "../assets/logo.png";
import axios from "axios";
import { Newspaper, Home as HomeIcon, LogOut } from "lucide-react"; 

// Dropdown Component
const DropdownMenu = ({ title, index, openIndex, setOpenIndex, children }) => {
  const isOpen = openIndex === index;
  const toggleDropdown = () => setOpenIndex(isOpen ? null : index);

  return (
    <div className={`dropdown-menu ${isOpen ? "open" : ""}`}>
      <p onClick={toggleDropdown} className="dropdown-title">
        {title}
        <span className={`arrow ${isOpen ? "rotate" : ""}`}>▼</span>
      </p>
      {isOpen && <ul className="dropdown-list">{children}</ul>}
    </div>
  );
};

const AdminNav = () => {
  const navigate = useNavigate();
  const storedUser = localStorage.getItem("username");
  const storedBranch = localStorage.getItem("branch");
  const storedMemId = localStorage.getItem("memberId");
  const siteName = localStorage.getItem("company");

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // state for all menus
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [data3, setData3] = useState([]);
  const [data4, setData4] = useState([]);
  const [data5, setData5] = useState([]);
  const [data6, setData6] = useState([]);
  const [data7, setData7] = useState([]);

  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    fetchData();
    fetchData1();
    fetchData2();
    fetchData3();
    fetchData4();
    fetchData5();
    fetchData6();
    fetchData7();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storedMemId]);

  // --- Utility fetcher ---
  const safeSetData = (setter, response, keyName) => {
    if (Array.isArray(response.data)) {
      setter(response.data);
    } else if (response.data && Array.isArray(response.data[keyName])) {
      setter(response.data[keyName]);
    } else {
      setter([]);
    }
  };

  const fetchData = async () => {
    try {
      const res = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/inventory_navMaster?memId=${storedMemId}`
      );
      safeSetData(setData, res, "InventoryMaster");
    } catch (e) {
      console.error("Error Fetching Master:", e);
    }
  };

  const fetchData1 = async () => {
    try {
      const res = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/inventory_navTrans_1?memId=${storedMemId}`
      );
      safeSetData(setData1, res, "InventoryTrans");
    } catch (e) {
      console.error("Error Fetching Trans 1:", e);
    }
  };

  const fetchData2 = async () => {
    try {
      const res = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/inventory_navTrans_2?memId=${storedMemId}`
      );
      safeSetData(setData2, res, "InventoryTrans2");
    } catch (e) {
      console.error("Error Fetching Trans 2:", e);
    }
  };

  const fetchData3 = async () => {
    try {
      const res = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/inventory_navTrans_3?memId=${storedMemId}`
      );
      safeSetData(setData3, res, "InventoryTrans3");
    } catch (e) {
      console.error("Error Fetching Trans 3:", e);
    }
  };

  const fetchData4 = async () => {
    try {
      const res = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/inventory_navTrans_4?memId=${storedMemId}`
      );
      safeSetData(setData4, res, "InventoryTrans4");
    } catch (e) {
      console.error("Error Fetching Trans 4:", e);
    }
  };

  const fetchData5 = async () => {
    try {
      const res = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/inventory_navTrans_5?memId=${storedMemId}`
      );
      safeSetData(setData5, res, "InventoryTrans5");
    } catch (e) {
      console.error("Error Fetching Trans 5:", e);
    }
  };

  const fetchData6 = async () => {
    try {
      const res = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/inventory_navRepot_1?memId=${storedMemId}`
      );
      safeSetData(setData6, res, "InventoryRpt1");
    } catch (e) {
      console.error("Error Fetching Report 1:", e);
    }
  };

  const fetchData7 = async () => {
    try {
      const res = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/inventory_navRepot_2?memId=${storedMemId}`
      );
      safeSetData(setData7, res, "InventoryRpt2");
    } catch (e) {
      console.error("Error Fetching Report 2:", e);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("branch");
    navigate("/login", { replace: true });
  };

  return (
    <div className={`admin-nav-container ${isMenuOpen ? "open" : ""}`}>
      {/* Top Header (Mobile) */}
      <div className="admin-nav-header">
        <img src={Logo} alt="logo" className="school--logo-mobile" />
        <button
          className="menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          ☰
        </button>
      </div>

      {/* Sidebar */}
      <div id="nav-container" className={`${isMenuOpen ? "show" : ""}`}>
        <div className="img-flex">
          <div className="logo-container">
            <img src={Logo} alt="logo" className="school--logo" />
          </div>
        </div>

        <div className="user-info">
          <p>
            Company: <b>{siteName}</b>
          </p>
          <p>
            User: <b>{storedUser}</b>
          </p>
          <p>
            Branch: <b>{storedBranch}</b>
          </p>
        </div>

        <div className="content-left">
          <ul>
            {/* Master */}
            <DropdownMenu
              title="Master Module"
              index={0}
              openIndex={openDropdown}
              setOpenIndex={setOpenDropdown}
            >
              {data.map((item, idx) => (
                <Link key={idx} to={`/inventory/${item.links}`}>
                  <li>{item.title}</li>
                </Link>
              ))}
            </DropdownMenu>

            {/* Transaction */}
            <DropdownMenu
              title="Transaction"
              index={1}
              openIndex={openDropdown}
              setOpenIndex={setOpenDropdown}
            >
              <div className="section-divider"><span>Section - I</span></div>
              {data1.map((item, idx) => (
                <Link key={idx} to={`/inventory/${item.links}`}>
                  <li>{item.title}</li>
                </Link>
              ))}

              <div className="section-divider"><span>Section - II</span></div>
              {data2.map((item, idx) => (
                <Link key={idx} to={`/inventory/${item.links}`}>
                  <li>{item.title}</li>
                </Link>
              ))}

              <div className="section-divider"><span>Section - III</span></div>
              {data3.map((item, idx) => (
                <Link key={idx} to={`/inventory/${item.links}`}>
                  <li>{item.title}</li>
                </Link>
              ))}

              <div className="section-divider"><span>Section - IV</span></div>
              {data4.map((item, idx) => (
                <Link key={idx} to={`/inventory/${item.links}`}>
                  <li>{item.title}</li>
                </Link>
              ))}

              <div className="section-divider"><span>Section - V</span></div>
              {data5.map((item, idx) => (
                <Link key={idx} to={`/inventory/${item.links}`}>
                  <li>{item.title}</li>
                </Link>
              ))}
            </DropdownMenu>

            {/* Report */}
            <DropdownMenu
              title="Report"
              index={2}
              openIndex={openDropdown}
              setOpenIndex={setOpenDropdown}
            >
              <div className="section-divider"><span>Report - I</span></div>
              {data6.map((item, idx) => (
                <Link key={idx} to={`/inventory/${item.links}`}>
                  <li>{item.title}</li>
                </Link>
              ))}

              <div className="section-divider"><span>Report - II</span></div>
              {data7.map((item, idx) => (
                <Link key={idx} to={`/inventory/${item.links}`}>
                  <li>{item.title}</li>
                </Link>
              ))}
            </DropdownMenu>
          </ul>
        </div>

        {/* Buttons area */}
        <div className="nav_buttons">
          {/* Logout on top */}
           <div className="nav-quick">
            <Link to="/components/flashNews">
              <button className="flash-btn">
                <Newspaper size={16} className="ico" />
                Flash News
              </button>
            </Link>

            <Link to="/home">
              <button className="home-btn">
                <HomeIcon size={16} className="ico" />
                Home
              </button>
            </Link>
          </div>
          <button onClick={handleLogout} className="logout">
            <LogOut size={16} className="ico" />
            Logout
          </button>

          {/* Quick actions row (Flash + Home) below */}
         
        </div>
      </div>
    </div>
  );
};

export default AdminNav;
